import store from "../../store/index";
import apiOffice from "../axios/apiOffice";

class AppointmentService {
  static async getTimesForDate(date, areaid) {
    try {
      const data = {
        areaId: areaid,
        appointmentDay: date,
      };
      const response = await apiOffice.post(`/appointments/find-times`, data);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting availables times:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getAppointmentsByWeek() {
    try {
      const response = await apiOffice.get(`/appointments/appointments-by-week`);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting availables times:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getAppointmentsFiltered(filters) {
    try {
      const body = {conditions: filters}
      const response = await apiOffice.post(`/appointments/filter`, body);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting availables times:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async createAppointment(body) {
    try {
      const cidiCookie = store.state.CidiCookie; // Access state from Vuex store
      body.cidi = cidiCookie; // Add CIDI cookie to the request body
      const response = await apiOffice.post(
        `/appointments/schedule-appointment-muni`,
        body
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error creating appointment:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async missedAppointment(id) {
    try {
      const response = await apiOffice.put(
        `/appointments/missed-appointment/${id}`
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error creating appointment:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getScheduledAppointments() {
    try {
      const response = await apiOffice.get(`/appointments/get-scheduled-appointments/`);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting appointments:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async finishAppointment(id) {
    try {
      const response = await apiOffice.put(
        `/appointments/finish-appointment/${id}`
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error creating appointment:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
  
  static async cancelAppointment(body) {
    try {
      const response = await apiOffice.post(
        `/appointments/muni-cancel-appointment`,
        body
      );
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: response?.data?.message?.includes("CiDi") ? true : false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error creating appointment:", error);
      return {
        success: error.response?.data?.message?.includes("CiDi") ? true : false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default AppointmentService;
